import { render, staticRenderFns } from "./EmployeeDetailPage.vue?vue&type=template&id=52413eba&scoped=true&lang=pug&"
import script from "./EmployeeDetailPage.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDetailPage.vue?vue&type=style&index=0&id=52413eba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52413eba",
  null
  
)

export default component.exports